export const ORG = {
  name: "Consecrated Hands",
  logo: "/img/consecrated-hands-approved-logo.webp",
  ein: "33-4903145",
  taxStatus: "Federally recognized 501(c)(3) public charity",
  donationUrl: process.env.REACT_APP_STRIPE_PAYMENT_LINK || "",
  mission: "Consecrated Hands is a Christ-centered youth mentorship nonprofit helping young people discover who God created them to become through faith, stability, education, life skills, opportunity, healthy relationships, character, leadership, and service.",
  contacts: [{ name: "Justin Mata", title: "Founder & Executive Director", phone: "504-539-1771" }],
  email: "OurConsecratedHands@Gmail.com",
  socials: [],
};

export const PILLARS = [
  { n:"01", title:"Faith & Identity", desc:"Helping young people know Christ, understand their God-given worth, and build a spiritual foundation." },
  { n:"02", title:"Stability & Essential Needs", desc:"Strengthening safety, consistency, trusted relationships, and the basic support needed to grow." },
  { n:"03", title:"Education & Development", desc:"Tutoring, academic encouragement, GED pathways, study habits, confidence, and continued learning." },
  { n:"04", title:"Life & Financial Skills", desc:"Budgeting, saving, stewardship, responsibility, decision-making, and practical preparation for adulthood." },
  { n:"05", title:"Career & Opportunity", desc:"Career exposure, job readiness, employment connections, and a vision for meaningful work." },
  { n:"06", title:"Health, Relationships & Character", desc:"Building wellness, discipline, integrity, confidence, resilience, and healthy relationships." },
  { n:"07", title:"Service, Leadership & Giving Back", desc:"Helping youth turn growth outward so they can lead, serve, encourage, and strengthen someone else." },
];

export const VALUES = [
  { n:"01", title:"Christ at the Center", body:"Everything we do is rooted in Jesus, grace, truth, prayer, and purpose." },
  { n:"02", title:"Relationship First", body:"Trust is built through consistency. We show up, listen, encourage, and walk with young people over time." },
  { n:"03", title:"Whole-Life Mentorship", body:"The Web of Consecration™ connects the areas of life that strengthen one another instead of treating needs in isolation." },
  { n:"04", title:"From Help to Leadership", body:"The goal is movement from needing support to becoming someone who can support and lead others." },
];

export const TRUTH = {
  eyebrow: "Created Intentionally",
  headline: "You were set apart for more than survival.",
  body: "We believe every young person has God-given value, purpose, and potential. Consecrated Hands helps them discover it and build the support, skills, relationships, and opportunities to live it out.",
  verse: "\"For you formed my inmost being… I praise you, for I am fearfully and wonderfully made.\" — Psalm 139:13–14",
};

export const IMPACT = [];
export const TESTIMONIALS = [];
export const EVENTS = [];
export const FAQ = [
  { q:"Who does Consecrated Hands serve?", a:"We focus on young people roughly ages 7–17 who need positive mentorship, stability, encouragement, opportunity, and Christ-centered guidance." },
  { q:"What is The Web of Consecration™?", a:"It is our seven-strand whole-life mentorship framework connecting faith, stability, education, practical skills, opportunity, relationships and character, leadership, and service." },
  { q:"Is Consecrated Hands Christian?", a:"Yes. Consecrated Hands is unapologetically Christ-centered while delivering practical, professional youth mentorship." },
  { q:"Is my donation tax-deductible?", a:"Consecrated Hands is a federally recognized 501(c)(3) public charity. Contributions may be tax-deductible to the fullest extent allowed by law." },
];
export const MANIFESTO = ["Faith & Identity","Education","Opportunity","Character","Leadership","Service","Become Who God Set You Apart to Be"];
export const HERO_BG = "/img/hero.webp";
export const STAINED_GLASS = "/img/church-youth.webp";
export const IMAGES = {
  heroFaith:"/img/church-youth.webp",
  stainedGlass:"/img/church-youth.webp",
  mentorship:"/img/impact.webp",
  youthStudying:"/img/IMG_1991.jpeg",
  youthPortrait:"/img/IMG_1993.jpeg",
  volunteering:"/img/IMG_1996.jpeg",
  kidsSun:"/img/about.webp",
  sportsMentor:"/img/mission.webp",
  mentorshipReading:"/img/mentorship-reading.webp",
  volunteerSupplies:"/img/volunteer-school-supplies.webp",
  prayerGathering:"/img/youth-prayer.webp",
  basketballMentoring:"/img/basketball-mentoring.webp",
  basketballReal:"/img/youth-basketball-real.webp",
  soccerReal:"/img/youth-soccer-real.webp",
  scienceClass:"/img/science-class-real.webp",
  classroomReal:"/img/IMG_1979.jpeg",
  educationMentorship:"/img/education-mentorship-library.webp",
  sportsMission:"/img/sports-community-basketball-practice.webp",
  faithPrayer:"/img/IMG_5369.jpeg",
};
